import React from 'react'
import Navbar from '../../components/landingPageComponent/Navbar'
import CustomizeAdminPortal from '../../components/otherComponents/CustomizeAdminPortal'

const CustomizeAdmin = () => {
  return (
    <>
      <Navbar />
      <CustomizeAdminPortal/>
    </>
  )
}

export default CustomizeAdmin